export const numberWithCommas = (e) => (e === null || typeof e === 'undefined' ? 0 : e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

export const nairaAmount = (e) => {
  const n = e != null && typeof e === 'number' ? e : 0;
  return `₦ ${numberWithCommas(n)}`;
};

export const capitalizeInitialLetter = (str) => str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};
